module.exports = __webpack_public_path__ + "img/W-G11.5e1fe968.jpg";